export const NavigationIcon = ({ theme }: { theme: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.75195 2.50195C8.98207 2.50195 9.16862 2.6885 9.16862 2.91862V3.75195C9.16862 3.98207 8.98207 4.16862 8.75195 4.16862H5.00195C4.54172 4.16862 4.16862 4.54172 4.16862 5.00195L4.16862 15.002C4.16862 15.4622 4.54172 15.8353 5.00195 15.8353H8.75195C8.98207 15.8353 9.16862 16.0218 9.16862 16.252V17.0853C9.16862 17.3154 8.98207 17.502 8.75195 17.502H5.00195C3.62124 17.502 2.50195 16.3827 2.50195 15.002L2.50195 5.00195C2.50195 3.62124 3.62124 2.50195 5.00195 2.50195L8.75195 2.50195ZM17.3762 10.2966C17.5389 10.1339 17.5389 9.87004 17.3762 9.70733L14.0429 6.37399C13.8802 6.21127 13.6163 6.21127 13.4536 6.37399L12.8644 6.96325C12.7017 7.12597 12.7017 7.38978 12.8644 7.5525L14.4805 9.16862L6.909 9.16862C6.67888 9.16862 6.49233 9.35517 6.49233 9.58529V10.4186C6.49233 10.6487 6.67888 10.8353 6.909 10.8353H14.4805L12.8644 12.4514C12.7017 12.6141 12.7017 12.8779 12.8644 13.0407L13.4536 13.6299C13.6163 13.7926 13.8802 13.7926 14.0429 13.6299L17.3762 10.2966Z"
        fill={theme === 'light' ? '#343434' : '#FFFFFF'}
      />
    </svg>
  );
};
